
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[nonprofitSlugOrUsername]/donations",
      function () {
        return require("private-next-pages/[nonprofitSlugOrUsername]/donations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[nonprofitSlugOrUsername]/donations"])
      });
    }
  